<div class="ds-grid ds-grid--3">
	<!-- Primary Icon Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Primary Icon Buttons</h3>
			<p class="ds-example__header-subtitle">Standard, outlined, and text variants</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[variant]="'icon'"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Add'"
					[size]="'small'"
					(action)="onButtonClick('Icon Primary')">
				</eif-custom-button>
				<eif-custom-button
					[variant]="['icon', 'outlined']"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Edit'"
					[size]="'small'"
					(action)="onButtonClick('Icon Primary Outlined')">
				</eif-custom-button>
				<eif-custom-button
					[variant]="['icon', 'text']"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Delete'"
					[size]="'small'"
					(action)="onButtonClick('Icon Primary Text')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Success Icon Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Success Icon Buttons</h3>
			<p class="ds-example__header-subtitle">Standard, outlined, and text variants</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[color]="'success'"
					[variant]="'icon'"
					[preIcon]="'fa-regular fa-plus'"
					[tooltip]="'Confirm'"
					[size]="'small'"
					(action)="onButtonClick('Icon Success')">
				</eif-custom-button>
				<eif-custom-button
					[color]="'success'"
					[variant]="['icon', 'outlined']"
					[preIcon]="'fa-regular fa-plus'"
					[tooltip]="'Approve'"
					[size]="'small'"
					(action)="onButtonClick('Icon Success Outlined')">
				</eif-custom-button>
				<eif-custom-button
					[color]="'success'"
					[variant]="['icon', 'text']"
					[preIcon]="'fa-regular fa-plus'"
					[tooltip]="'Verify'"
					[size]="'small'"
					(action)="onButtonClick('Icon Success Text')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Info Icon Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Info Icon Buttons</h3>
			<p class="ds-example__header-subtitle">Standard, outlined, and text variants</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[color]="'info'"
					[variant]="'icon'"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Information'"
					[size]="'small'"
					(action)="onButtonClick('Icon Info')">
				</eif-custom-button>
				<eif-custom-button
					[color]="'info'"
					[variant]="['icon', 'outlined']"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Help'"
					[size]="'small'"
					(action)="onButtonClick('Icon Info Outlined')">
				</eif-custom-button>
				<eif-custom-button
					[color]="'info'"
					[variant]="['icon', 'text']"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Details'"
					[size]="'small'"
					(action)="onButtonClick('Icon Info Text')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Warning Icon Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Warning Icon Buttons</h3>
			<p class="ds-example__header-subtitle">Standard, outlined, and text variants</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[color]="'warning'"
					[variant]="'icon'"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Warning'"
					[size]="'small'"
					(action)="onButtonClick('Icon Warning')">
				</eif-custom-button>
				<eif-custom-button
					[color]="'warning'"
					[variant]="['icon', 'outlined']"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Alert'"
					[size]="'small'"
					(action)="onButtonClick('Icon Warning Outlined')">
				</eif-custom-button>
				<eif-custom-button
					[color]="'warning'"
					[variant]="['icon', 'text']"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Caution'"
					[size]="'small'"
					(action)="onButtonClick('Icon Warning Text')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Danger Icon Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Danger Icon Buttons</h3>
			<p class="ds-example__header-subtitle">Standard, outlined, and text variants</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[color]="'danger'"
					[variant]="'icon'"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Close'"
					[size]="'small'"
					(action)="onButtonClick('Icon Danger')">
				</eif-custom-button>
				<eif-custom-button
					[color]="'danger'"
					[variant]="['icon', 'outlined']"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Delete'"
					[size]="'small'"
					(action)="onButtonClick('Icon Danger Outlined')">
				</eif-custom-button>
				<eif-custom-button
					[color]="'danger'"
					[variant]="['icon', 'text']"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Remove'"
					[size]="'small'"
					(action)="onButtonClick('Icon Danger Text')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Disabled Icon Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Disabled State</h3>
			<p class="ds-example__header-subtitle">Cannot be interacted with</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[variant]="'icon'"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Disabled'"
					[disabled]="true"
					[size]="'small'"
					(action)="onButtonClick('Icon Disabled')">
				</eif-custom-button>
				<eif-custom-button
					[variant]="['icon', 'outlined']"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Disabled'"
					[disabled]="true"
					[size]="'small'"
					(action)="onButtonClick('Icon Disabled Outlined')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Sizes -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Icon Button Sizes</h3>
			<p class="ds-example__header-subtitle">Small, medium, and large sizes</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[variant]="'icon'"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Add'"
					[size]="'small'"
					(action)="onButtonClick('Icon Small')">
				</eif-custom-button>
				<eif-custom-button
					[variant]="'icon'"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Add'"
					[size]="'medium'"
					(action)="onButtonClick('Icon Medium')">
				</eif-custom-button>
				<eif-custom-button
					[variant]="'icon'"
					[preIcon]="'fa-solid fa-plus'"
					[tooltip]="'Add'"
					[size]="'large'"
					(action)="onButtonClick('Icon Large')">
				</eif-custom-button>
			</div>
		</div>
	</div>
</div>
